import React from "react";
import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Legend,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';

const ResumeRadarSelfcare360 = ({ dimensions, totalsByKey, expectedMin = 85 }) => {
    if (!dimensions || !totalsByKey) return null;

    const radarData = dimensions.map((dim) => ({
        subject: dim.title,
        individual: dim.average,
        total: totalsByKey?.[dim.key]?.average ?? 0,
        expected: expectedMin,
    }));

    // C-11: Determinar si existe base estadÃ­stica vÃ¡lida (todos los promedios organizacionales son 0)
    const hasOrgData = radarData.some(d => d.total > 0);

    return (
        <>
            <ResponsiveContainer width="100%" height={360}>
                <RadarChart data={radarData}>
                    <PolarGrid radialLines stroke="#ccc" strokeWidth={1.5} />
                    <PolarAngleAxis
                        dataKey="subject"
                        tick={{ fontSize: 11, width: 200 }}
                    />
                    <PolarRadiusAxis
                        angle={30}
                        domain={[0, 100]}
                        ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                        tick={{ fontSize: 11 }}
                        axisLine={{ strokeWidth: 2 }}
                        tickLine={{ strokeWidth: 1.5 }}
                    />

                    <Radar
                        name="Supervisor evaluado"
                        dataKey="individual"
                        stroke="#008000"
                        strokeWidth={2.5}
                        fill="transparent"
                        dot={{ r: 3, stroke: '#008000', strokeWidth: 1, fill: '#008000' }}
                    />

                    {hasOrgData && (
                        <Radar
                            name="Promedio planta (referencial)"
                            dataKey="total"
                            stroke="#3E246B"
                            strokeWidth={2.5}
                            fill="transparent"
                            strokeDasharray="6 4"
                            dot={{ r: 3, stroke: '#3E246B', strokeWidth: 1, fill: '#3E246B' }}
                        />
                    )}

                    <Radar
                        name="Meta esperada"
                        dataKey="expected"
                        stroke="#43a047"
                        strokeWidth={2.5}
                        fill="transparent"
                        strokeDasharray="2 4"
                        dot={{ r: 0 }}
                    />

                    <Legend />
                    <Tooltip />
                </RadarChart>
            </ResponsiveContainer>
            {!hasOrgData && (
                <div style={{ textAlign: 'center', fontSize: '11px', color: '#666', marginTop: '10px' }}>
                    <i>* El promedio organizacional se calcula a partir de la segunda ronda de evaluaciones.</i>
                </div>
            )}
        </>

    );
};

export default ResumeRadarSelfcare360;
